<script>
  import Checkbox from '../elements/Checkbox.svelte';
  import {VARIANT} from '../../constants';

  export let vendor = null;
  export let className = `scmp_FancyCheckbox${VARIANT}--vendorList`;

  const addClassTextToData = (array, classText) => {
    return array.map(vendorId => ({vendorId, className: `scmp_icon-${classText}-${vendorId}`}));
  };

  const getPurposesClasses = () => {
    const purposesId = addClassTextToData(vendor.purposeIds, 'p-black');
    const legIntPurposeIds = addClassTextToData(vendor.legIntPurposeIds, 'p-grey');

    return [...purposesId, ...legIntPurposeIds].sort((a, b) => a.id - b.id).map(item => item.className);
  };
</script>

<div class="scmp_Vendor">
  <div class="scmp_Vendor-name">
    {#if vendor.policyUrl}
      <a class="scmp_Vendor-url" href={vendor.policyUrl} target="_blank">{vendor.name}</a>
      <div class="scmp_Icons">
        {#each getPurposesClasses() as purposeClass}
          <span class={purposeClass} />
        {/each}
        {#each vendor.featureIds as feature}
          <span class={`scmp_icon-f-black-${feature}`} />
        {/each}
      </div>
    {:else}{vendor.name}{/if}
  </div>
  <Checkbox on:change value={vendor.id} id={vendor.id} checked={vendor.checked} {className} />
</div>
